
import LocaleChanger from '../default/LocaleChanger'
import ProfileDropDown from '../default/ProfileDropDown'
import TheSearch from './TheSearch'

export default {
  name: 'DashboardMenuTop',
  components: { ProfileDropDown, TheSearch, LocaleChanger },
  props: {
    value: Boolean
  },
  methods: {
    onLogout () {
      this.$router.push(this.localePath('index'))
    }
  }
}
